import { render, staticRenderFns } from "./VincularMonitoramentoModal.vue?vue&type=template&id=146a4544&scoped=true"
import script from "./VincularMonitoramentoModal.vue?vue&type=script&lang=js"
export * from "./VincularMonitoramentoModal.vue?vue&type=script&lang=js"
import style0 from "./VincularMonitoramentoModal.vue?vue&type=style&index=0&id=146a4544&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146a4544",
  null
  
)

export default component.exports